import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Form } from './components';
import { Image } from 'components/atoms';
import { LearnMoreLink } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { HeroShaped } from 'components/organisms';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { callGetApi } from 'utils/networking';
import { useDispatch } from 'react-redux';
import { setProfile } from 'redux/actions/AuthActions';

const useStyles = makeStyles(theme => ({
    root: {
        '& .hero-shaped': {
            borderBottom: 0,
        },
        '& .hero-shaped__wrapper': {
            [theme.breakpoints.up('md')]: {
                minHeight: `calc(100vh - ${theme.mixins.toolbar['@media (min-width:600px)'].minHeight}px)`,
            },
        },
    },
    formContainer: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 500,
            margin: `0 auto`,
        },
    },
    image: {
        objectFit: 'cover',
    },
}));

const VerifyPhone = () => {
    const classes = useStyles();
    let { type, id } = useParams();
    const dispatch = useDispatch();
    let history = useHistory();

    useEffect(() => {
        
    }, [])

    return (
        <div className={classes.root}>
            <HeroShaped
                leftSide={
                    <div className={classes.formContainer}>
                        <SectionHeader
                            title="Verify Phone"
                            subtitle={
                                <span>
                                    Please verify to continue
                                </span>
                            }
                            titleProps={{
                                variant: 'h3',
                            }}
                        />
                        <Form
                            type={type}
                            id={id} />
                    </div>
                }
                rightSide={
                    <Image
                        src="https://assets.maccarianagency.com/the-front/photos/account/cover-1.png"
                        className={classes.image}
                        lazy={false}
                    />
                }
            />
        </div>
    );
};

export default VerifyPhone;
